// Global state management
let state = {
    content: null,
    products: null,
    cart: [],
    currentPage: 'home'
};

// Initialise store with saved cart if available
export function initStore() {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
        try {
            state.cart = JSON.parse(savedCart);
        } catch (e) {
            console.error('Failed to parse saved cart', e);
        }
    }
}

// Content getters and setters
export function getContent() {
    return state.content;
}

export function setContent(content) {
    state.content = content;
}

// Products getters and setters
export function getProducts() {
    return state.products;
}

export function setProducts(products) {
    state.products = products;
}

// Cart methods
export function getCart() {
    return state.cart;
}

export function addToCart(item) {
    const existingItem = state.cart.find(
        cartItem => cartItem.id === item.id && cartItem.size === item.size
    );

    if (existingItem) {
        existingItem.quantity += 1;
    } else {
        state.cart.push({...item, quantity: 1});
    }

    // Save cart to localStorage
    saveCart();

    return [...state.cart]; // Return a copy
}

export function removeFromCart(index) {
    state.cart.splice(index, 1);
    saveCart();
}

export function updateCartItemQuantity(index, quantity) {
    if (index >= 0 && index < state.cart.length) {
        state.cart[index].quantity = quantity;
        saveCart();
    }
}

export function clearCart() {
    state.cart = [];
    saveCart();
}

function saveCart() {
    localStorage.setItem('cart', JSON.stringify(state.cart));
}

// Current page getter and setter
export function getCurrentPage() {
    return state.currentPage;
}

export function setCurrentPage(page) {
    state.currentPage = page;
}